/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Refresh_DraftInputs */

const vi_einvoice_refresh_draft = /** @type {(inputs: Einvoice_Refresh_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật nháp`)
};

/**

* @param {Einvoice_Refresh_DraftInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_refresh_draft = /** @type {((inputs?: Einvoice_Refresh_DraftInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Refresh_DraftInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_refresh_draft(inputs)
});